import React from 'react';

import PageContext from './context';
import { i18n }    from './i18n';

export default function ModalImage({ src, path, children, className }) {
    if (path) {
        src = i18n(path, { md : false, errorText : false, fallback : false });
    }

    return (
        src ?
            <PageContext.Consumer>
                {({ openModal }) => (
                    <a
                        onClick={(e) => {
                            e.preventDefault();

                            openModal(src);
                        }}
                        className={className}
                        href={src}
                    >
                        {children}
                    </a>
                )}
            </PageContext.Consumer> :
            <span className={className}>{ children }</span>
    );
}
